import type { StaffArea } from '@/pages/staffNavigation'
import type { StaffModule } from '@/pages/staffCapabilities'

const AREA_MODULES: Partial<Record<StaffArea, StaffModule>> = {
  'event-registrations': 'events',
  connections: 'connections',
  'unmatched-items': 'connection_unmatched',
  members: 'membership',
  'membership-levels': 'membership',
  'renewal-pipeline': 'membership',
  engagement: 'membership',
  'finance-overview': 'finance',
  'financial-history': 'finance',
  'finance-invoices': 'finance',
  'finance-autopay-recovery': 'finance',
  'finance-tax-report': 'finance',
  'finance-income-report': 'finance',
  'finance-collections-report': 'finance',
  'finance-aging-report': 'finance',
  'finance-recognition-schedule': 'finance',
  'finance-payouts': 'finance',
  'finance-unreachable-members': 'finance',
  'finance-donations': 'finance',
  'finance-campaigns': 'finance',
  'communication-email-log': 'communications',
  'communication-blasts': 'communications',
  'communication-audiences': 'communications',
  events: 'events',
  courses: 'courses',
  contacts: 'contacts',
  chapters: 'contacts',
  'contact-duplicates': 'contacts',
  'contact-import': 'contacts',
  'finance-settings': 'association_settings',
  'discount-codes': 'finance',
  'accounting-settings': 'finance',
  'admin-directory-settings': 'association_settings',
  seats: 'association_settings',
}

export function moduleForArea(area: StaffArea) {
  return AREA_MODULES[area] ?? 'association_settings'
}
